export default {
  products: [],
};
